(() => {
  'use strict';
  const log = (level, operation, context = {}) => {
    const entry = { timestamp: new Date().toISOString(), level, module: 'mms-product-gallery.js', operation, ...context };
    (level === 'ERROR' ? console.error : console.info)(entry);
  };
  document.querySelectorAll('[data-mms-gallery]').forEach(root => {
    if (root.dataset.initialized) return;
    try {
      const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
      const main = root.querySelector('[data-gallery-main]');
      const stage = root.querySelector('[data-gallery-stage]');
      const dialog = root.querySelector('dialog');
      const zoomImage = dialog.querySelector('img');
      const opener = root.querySelector('[data-gallery-open]');
      const lightboxThumbs = [...root.querySelectorAll('[data-lightbox-thumb]')];
      const zoomViewport = dialog.querySelector('.mms-zoom-viewport');
      const zoomToggle = dialog.querySelector('[data-gallery-zoom]');
      let previousOverflow = '';
      const resetZoom = () => { zoomViewport.classList.remove('is-zoomed'); zoomToggle.setAttribute('aria-pressed','false'); zoomToggle.textContent='Zoom in +'; zoomViewport.scrollTo(0,0); };
      const toggleZoom = () => { const zoomed=zoomViewport.classList.toggle('is-zoomed'); zoomToggle.setAttribute('aria-pressed',String(zoomed));zoomToggle.textContent=zoomed?'Fit photo −':'Zoom in +';if(zoomed)zoomViewport.scrollTo(zoomViewport.clientWidth/2,zoomViewport.clientHeight/2);else zoomViewport.scrollTo(0,0); };
      zoomToggle.addEventListener('click',toggleZoom);
      zoomImage.addEventListener('click',toggleZoom);
      const header = document.querySelector('#mms-storefront .header');
      const mediaColumn = root.closest('.mms-product-media-column');
      const syncHeader = () => {
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        root.style.setProperty('--mms-header-height', `${headerHeight}px`);
        if (mediaColumn) {
          // Tall columns scroll naturally before their bottom edge stays in view.
          // This keeps details reachable without a nested scroll area or an empty left rail.
          const offset = Math.min(headerHeight + 20, window.innerHeight - mediaColumn.offsetHeight - 24);
          mediaColumn.style.setProperty('--mms-media-stick-offset', `${offset}px`);
        }
      };
      syncHeader();
      window.addEventListener('resize', syncHeader, { passive: true });
      if (typeof ResizeObserver !== 'undefined') {
        const layoutObserver = new ResizeObserver(syncHeader);
        if (header) layoutObserver.observe(header);
        if (mediaColumn) layoutObserver.observe(mediaColumn);
      }
      let index = 0;
      let gesture = null;
      let suppressClick = false;
      if (!main || !thumbs.length) return;
      const scrollThumb = () => {
        const selected = thumbs[index];
        const strip = selected.parentElement;
        if (matchMedia('(max-width: 760px)').matches) {
          const left = selected.offsetLeft - strip.offsetLeft;
          if (left < strip.scrollLeft || left + selected.offsetWidth > strip.scrollLeft + strip.clientWidth)
            strip.scrollLeft = left - (strip.clientWidth - selected.offsetWidth) / 2;
        } else {
          const top = selected.offsetTop - strip.offsetTop;
          if (top < strip.scrollTop || top + selected.offsetHeight > strip.scrollTop + strip.clientHeight)
            strip.scrollTop = top - (strip.clientHeight - selected.offsetHeight) / 2;
        }
      };
      const show = next => {
        resetZoom();
        index = (next + thumbs.length) % thumbs.length;
        const current = thumbs[index];
        main.src = current.dataset.image;
        main.removeAttribute('srcset');
        main.alt = current.dataset.alt;
        zoomImage.src = current.dataset.full;
        zoomImage.alt = current.dataset.alt;
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === index)));
        root.querySelectorAll('[data-gallery-count]').forEach(count => { count.textContent = `${index + 1} / ${thumbs.length}`; });
        lightboxThumbs.forEach((thumb,i)=>thumb.setAttribute('aria-current',String(i===index)));
        if(dialog.open)lightboxThumbs[index]?.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});
        scrollThumb();
      };
      const variantSelect = document.querySelector('[data-product-form] [name=id]');
      const syncVariantPhoto = () => {
        const desired = variantSelect?.selectedOptions[0]?.dataset.variantImage;
        if (!desired) return;
        const imagePath = new URL(desired, location.href).pathname;
        const next = thumbs.findIndex(thumb => new URL(thumb.dataset.full, location.href).pathname === imagePath);
        if (next >= 0) show(next);
      };
      variantSelect?.addEventListener('change', syncVariantPhoto);
      lightboxThumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>show(i)));
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
      root.querySelectorAll('[data-gallery-step]').forEach(button => {
        button.hidden = thumbs.length < 2;
        button.addEventListener('click', () => show(index + Number(button.dataset.galleryStep)));
      });
      opener.addEventListener('click', () => {
        if (suppressClick) { suppressClick = false; return; }
        show(index);
        dialog.showModal();
        previousOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';
      });
      root.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => {document.documentElement.style.overflow=previousOverflow;resetZoom();opener.focus({ preventScroll: true });});
      dialog.addEventListener('click', event => {
        const rect = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
      });
      root.addEventListener('keydown', event => {
        if(event.target===zoomViewport && zoomViewport.classList.contains('is-zoomed'))return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        show(index + (event.key === 'ArrowRight' ? 1 : -1));
        if (event.target.hasAttribute('data-gallery-thumb')) thumbs[index].focus({ preventScroll: true });
      });
      stage.addEventListener('pointerdown', event => {
        suppressClick = false;
        gesture = event.pointerType === 'touch' ? { x: event.clientX, y: event.clientY } : null;
      });
      stage.addEventListener('pointerup', event => {
        if (!gesture) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        gesture = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          suppressClick = true;
          show(index + (dx < 0 ? 1 : -1));
        }
      });
      stage.addEventListener('pointercancel', () => { gesture = null; });
      syncVariantPhoto();
      root.dataset.initialized = 'true';
      log('INFO', '[GALLERY_READY]', { productId: root.dataset.productId, imageCount: thumbs.length });
    } catch (error) {
      log('ERROR', '[GALLERY_INITIALIZATION_FAILED]', { productId: root.dataset.productId, message: error.message, stack: error.stack });
    }
  });
})();
